/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { cn } from "@farmlands/shadcn-ui";
import { MapPin, Truck } from "lucide-react";

import { TestIds } from "../../../../testIds";

import { HEADER_BUTTON_STATE_CLASSES } from "./styles";

type PickupDeliveryButtonProps = {
  isDelivery: boolean;
  label: string;
  value: string;
  onClick: () => void;
};

export const PickupDeliveryButton = ({
  isDelivery,
  label,
  value,
  onClick,
}: PickupDeliveryButtonProps) => {
  const Icon = isDelivery ? Truck : MapPin;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={TestIds.components.cartHeader.pickupDeliveryShortcutButton}
      className={cn(
        "flex cursor-pointer items-center gap-2 rounded-sm px-2 py-2",
        HEADER_BUTTON_STATE_CLASSES
      )}
    >
      <Icon aria-hidden size={20} />
      <span className="flex flex-col items-start text-left">
        <span className="text-xs leading-[18px] font-semibold">{label}</span>
        <span
          className={`
            max-w-[30vw] truncate text-2xs leading-[18px] tracking-[0.07px] underline
            [text-decoration-skip-ink:none]
            [text-underline-position:from-font]
          `}
        >
          {value}
        </span>
      </span>
    </button>
  );
};
